import { Dialog, DialogContent } from "@mui/material";
import { Loader } from "./common/Loader";
import { LoaderClassic } from "./common/LoaderClassic";
import { LoadingCard } from "./common/LoadingCard";

export const LoaderComponent = ({ open, type = "classic", hideBackdrop = false }) => {
  return (
    <Dialog
      open={open}
      maxWidth="xs"
      PaperProps={{
        style: { backgroundColor: "transparent", boxShadow: "none" },
      }}
      hideBackdrop={hideBackdrop}
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 10000,
      }}
    >
      <DialogContent>
        {type === "spinner" ? (
          <Loader></Loader>
        ) : type === "classic" ? (
          <LoaderClassic></LoaderClassic>
        ) : type === "card" ? (
          <LoadingCard></LoadingCard>
        ) : (
          <></>
        )}
      </DialogContent>
    </Dialog>
  );
};
